import React from 'react';
import { Link } from 'react-router-dom';
import SUBSCRIPTION_STATUS from '@achievable-me/tundra-wizard/subscriptionStatus';
import { Button } from 'antd';
import { hasFullAccess } from '@achievable-me/tundra-wizard/auth';
import { firstContentPath } from '@achievable-me/tundra-wizard/contentHelpers';

import sharedStyles from '../sharedStyles.scss';

const ContentOutline = (props) => {
  const { currentUser, product, inflatedContent } = props;
  const { slug: productSlug } = product;
  const isSubscribed = hasFullAccess({ user: currentUser, product });

  return (
    <div className={sharedStyles.childLayout}>
      <div className={sharedStyles.header}>Achievable&apos;s content outline</div>
      <div className={sharedStyles.contentSegments}>
        {inflatedContent.map((content) => {
          const { availability } = content;

          const ctaText = (() => {
            if (isSubscribed) {
              return 'Read';
            }

            if (availability === SUBSCRIPTION_STATUS.free) {
              return 'Read for free';
            }

            return 'Preview';
          })();

          const path = firstContentPath({ content });

          return (
            <div key={content.key} className={sharedStyles.contentSegment}>
              <div className={sharedStyles.contentSegmentTitle}>{content.title}</div>
              <div className={sharedStyles.contentSegmentBody}>
                <div className={sharedStyles.contentSegmentDescription}>
                  {content.summary}
                </div>
                <Link to={path}>
                  <Button data-aaa="readContent" data-product-slug={productSlug}>
                    {ctaText}
                  </Button>
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContentOutline;
